import { render, staticRenderFns } from "./rateInfo.vue?vue&type=template&id=08d49e8a&scoped=true"
import script from "./rateInfo.vue?vue&type=script&lang=js"
export * from "./rateInfo.vue?vue&type=script&lang=js"
import style0 from "./rateInfo.vue?vue&type=style&index=0&id=08d49e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d49e8a",
  null
  
)

export default component.exports